import logger from "@utils/logger";
import axios from "../lib/axios";

export const TYPES = {
  SET_ADVERTISING: "SET_ADVERTISING",
  HIDE_RIBBON: "HIDE_RIBBON",
};

function setAdvertising(advertising) {
  return {
    type: TYPES.SET_ADVERTISING,
    advertising,
  };
}

export const getAdvertising = () => async (dispatch) => {
  try {
    const res = await axios.get("/settings/client_front");
    await dispatch(setAdvertising(res.data));
  } catch (err) {
    logger.error("WIP! Unable to get advertising.\nDetails :", err);
  }
}

export const closeRibbon = () => ({ type: TYPES.HIDE_RIBBON });
